module.exports = __webpack_public_path__ + "img/03-2-2销售预测.f3eb933f.svg";